import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';

/**
 * Host de los toasts globales basados en PrimeNG `MessageService`. No empuja
 * mensajes por sí mismo: cada flujo debe llamar a `MessageService.add(...)`
 * con la `key` correspondiente.
 *
 * Toasts disponibles:
 *  - default (sin key): notificaciones generales en bottom-center.
 *  - `quiz-rejected`: rechazo del cuestionario en top-center.
 */
@Component({
  selector: 'app-warning-toast',
  standalone: true,
  imports: [CommonModule, ToastModule],
  templateUrl: './warning-toast.component.html',
  styleUrls: ['./warning-toast.component.scss'],
})
export class WarningToastComponent {}
